module.exports = __webpack_public_path__ + "img/hr-artillery-wagon-cannon-barrel-14.0dc0e93b.png";